export default __webpack_public_path__ + "static/media/bitcoin.c5b53971.png";